import { render } from "./ResourceLimitTab.vue?vue&type=template&id=2965b8c2&scoped=true"
import script from "./ResourceLimitTab.vue?vue&type=script&lang=js"
export * from "./ResourceLimitTab.vue?vue&type=script&lang=js"

import "./ResourceLimitTab.vue?vue&type=style&index=0&id=2965b8c2&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2965b8c2"]])

export default __exports__